@if (keywordGroup) {
    <div
        class="agpr-keywordGroupSummary"
        [ngClass]="styleClass"
    >
        <div *ngIf="keywordGroup?.searchContexts?.length > 0">
            <ng-container *ngFor="let searchContext of keywordGroup.searchContexts; let last = last;">
            <span class="agpr-keywordGroupSummary-keyword">
                {{ searchContext.name | localize }}</span><ng-container *ngIf="!last">,</ng-container>
            </ng-container>
        </div>
        <div *ngIf="keywordGroup.and?.length > 0">
            <ng-container *ngFor="let andKeyword of keywordGroup.and; let last = last;">
                <span class="agpr-keywordGroupSummary-keyword">
                    {{ andKeyword }}
                </span>
                <span *ngIf="!last" class="agpr-keywordGroupSummary-operator">
                    {{ 'KeywordGroupSummary.and' | localize }}
                </span>
            </ng-container>
        </div>
        <div *ngIf="keywordGroup.or?.length > 0">
            <span *ngIf="keywordGroup.and?.length > 0" class="agpr-keywordGroupSummary-operator">
                {{ 'KeywordGroupSummary.and' | localize }}
            </span>
            (
            <ng-container *ngFor="let orKeyword of keywordGroup.or; let last = last;">
                <span class="agpr-keywordGroupSummary-keyword">
                    {{ orKeyword }}
                </span>
                <span *ngIf="!last" class="agpr-keywordGroupSummary-operator">
                    {{ 'KeywordGroupSummary.or' | localize }}
                </span>
            </ng-container>
            )
        </div>
        <div *ngIf="keywordGroup.not?.length > 0">
            <span class="agpr-keywordGroupSummary-operator">
                {{ 'KeywordGroupSummary.not' | localize }}
            </span>
            (
            <ng-container *ngFor="let notKeyword of keywordGroup.not; let last = last;">
                <span class="agpr-keywordGroupSummary-keyword">
                    {{ notKeyword }}
                </span>
                <span *ngIf="!last" class="agpr-keywordGroupSummary-operator">
                    {{ 'KeywordGroupSummary.or' | localize }}
                </span>
            </ng-container>
            )
        </div>
    </div>
}
